import {Event} from './event.model';

export class EventEvent {
  id: number;
  eventId: number;
  event: Event;

  assigned?: boolean;
}
